import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, fetchApi } from "@inmagik/react-crud"
import type { Collection } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useCollectionsList(params: Record<string, string> = {}) {
  return useList<Collection>(`${API_URL}/admin/collections`, {
    query: params,
  })
}

export function useCollection(id: number | undefined) {
  return useDetail<Collection>(`${API_URL}/admin/collections`, id?.toString())
}

export function useCreateCollection() {
  return useCreate<Collection>(`${API_URL}/admin/collections`, {
    encode: "formdata",
  })
}

export function useUpdateCollection() {
  return useUpdate<Collection>(`${API_URL}/admin/collections`, {
    encode: "formdata",
  })
}

export function useDeleteCollection() {
  return useDelete(`${API_URL}/admin/collections`)
}

export function usePartialUpdateCollection() {
  return usePartialUpdate<Collection>(`${API_URL}/admin/collections`)
}

export function useDeleteMultiCollection() {
  return useAction(`${API_URL}/admin/collections/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useCollectionLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/collections/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Collection>
  }, [])
}

export function useCollectionsLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/collections?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Collection[];}>
  }, [])
}
